module.exports = __webpack_public_path__ + "static/media/DEU.47c76a97.jpg";